// extracted by mini-css-extract-plugin
export var displayNone = "_pl-6";
export var imgContainer = "_pl-2";
export var overflowHidden = "_pl-3";
export var productInfoCardButtonContainer = "_pl-5";
export var productTitleText = "_pl-4";
export var rightArrow = "_pl-1";
export var rightArrowContainer = "_pl-0";